import { useLanguage } from "../../LanguageContext";
import { padIndex } from "../../lib/format";
import { socialIcon } from "../Icons";
import GlitchPortrait from "./GlitchPortrait";
import SectionTitle from "./SectionTitle";

export default function HeroSection() {
	const { text } = useLanguage();

	return (
		<section className="home-hero" aria-labelledby="about-title">
			<h1 className="sr-only">{text.site.displayName.join(" ")}</h1>
			<SectionTitle
				id="about"
				kicker={text.about.kicker}
				title={text.about.title}
				titleId="about-title"
			/>

			<div className="home-hero-layout">
				<div className="home-statement">
					<p>
						<strong>{text.about.statementLead}</strong>
					</p>
					<p>{text.about.statementBody}</p>
				</div>

				<div className="home-hero-facts">
					<div>
						<span>{text.about.placeLabel}</span>
						<ul className="place-list">
							{text.about.places.map((place) => (
								<li key={place}>
									<strong>{place}</strong>
								</li>
							))}
						</ul>
					</div>
					<div>
						<span>{text.about.modeLabel}</span>
						<strong>{text.site.role}</strong>
					</div>
					<div>
						<span>{text.about.languageLabel}</span>
						<ul className="place-list">
							{text.about.languages.map((language) => (
								<li key={language}>
									<strong>{language}</strong>
								</li>
							))}
						</ul>
					</div>
				</div>

				<GlitchPortrait
					src="/portrait_marco_bw.webp"
					srcSet="/portrait_marco_bw-480.webp 480w, /portrait_marco_bw-720.webp 720w, /portrait_marco_bw.webp 1000w"
					sizes="(max-width: 900px) calc(100vw - 8vw), min(32vw, 27.5rem)"
					alt={text.site.displayName.join(" ")}
					width={1000}
					height={1400}
				/>

				<div className="home-skills">
					<span className="home-skills-label">{text.about.skillsLabel}</span>
					<div className="home-skills-groups">
						{text.about.skills.map((group) => (
							<div key={group.title} className="home-skills-group">
								<strong>{group.title}</strong>
								<p>{group.items.join(", ")}</p>
							</div>
						))}
					</div>
				</div>
			</div>

			<div className="home-social-index">
				{text.site.socials.map((social, index) => {
					const Icon = socialIcon(social.id);
					const isMail = social.url.startsWith("mailto:");
					return (
						<a
							key={social.id}
							href={social.url}
							{...(isMail ? {} : { target: "_blank", rel: "noreferrer" })}
						>
							<span>{padIndex(index + 1)}</span>
							<Icon width="16" height="16" />
							<strong>{social.label}</strong>
						</a>
					);
				})}
			</div>
		</section>
	);
}
